import React from 'react';
import Hero from '../components/Hero';
import StatsSection from '../components/StatsSection';
import ServicesSection from '../components/ServicesSection';
import ServiceCardsSection from '../components/ServiceCardsSection';
import ResourcesSection from '../components/ResourcesSection';
import NewsSection from '../components/NewsSection';
import BlogCardsSection from '../components/BlogCardsSection';


const HomePage = () => {
  return (
    <div>
      <Hero />
      <StatsSection />
      <ServicesSection />
      <ServiceCardsSection />
      <ResourcesSection />
      <NewsSection />
      <BlogCardsSection />

      {/* More sections can be added here later */}
    </div>
  );
};

export default HomePage;
